import React from 'react';
import Cart from '../../Components/Cart/Cart';
import NavigationBar from '../../Components/NavigationBar/NavigationBar';

const CartPage = () => {
    return (
        <div>
            <NavigationBar></NavigationBar>
            <Cart></Cart>
        </div>
    );
};

export default CartPage;